import { AlertCircle, Loader2, RotateCcw, Save } from "lucide-react"

import { Button } from "@/components/ui/button"

interface UnsavedChangesBannerProps {
  routeCount: number
  isSaving: boolean
  onSaveAll: () => void
  onDiscardAll: () => void
}

export default function UnsavedChangesBanner({
  routeCount,
  isSaving,
  onSaveAll,
  onDiscardAll,
}: UnsavedChangesBannerProps) {
  return (
    <div className="flex-shrink-0 border-b border-amber-600 bg-amber-500">
      <div className="flex items-center justify-between px-6 py-2.5">
        <div className="flex items-center gap-2">
          <AlertCircle size={16} className="text-white" />
          <span className="text-sm font-medium text-white">
            You have unsaved changes ({routeCount} route
            {routeCount > 1 ? "s" : ""})
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onDiscardAll}
            className="h-7 gap-1.5 border-white/30 bg-white/10 text-xs font-medium text-white hover:bg-white/20"
          >
            <RotateCcw size={12} />
            Discard All
          </Button>
          <Button
            size="sm"
            onClick={onSaveAll}
            disabled={isSaving}
            className="h-7 gap-1.5 bg-white text-xs font-semibold text-amber-600 hover:bg-palette-jungleGreen000 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isSaving ? (
              <>
                <Loader2 size={12} className="animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save size={12} />
                Save All Changes
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
